// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectTags_root__3uHfQ","disabled":"SelectTags_disabled__3E0Xj"};